export default (state = {}) => {
  return {
    ...state,
    viewTeams: [],
    coachId: '',
    reportFilterCount: 0,
    reportCountAllOrg: 0,
    filters: {},
  };
};
